if (!customElements.get("cart-drawer-upsells")) {
  customElements.define(
    "cart-drawer-upsells",
    class CartDrawerUpsells extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector("#cart-upsell-toggle");
        this.cartItems = document.querySelector("#drawer__header");
        this.cartFooter = document.querySelector(".drawer__footer");
      }

      connectedCallback() {
        this.button.addEventListener("click", () => {
          this.classList.remove("horizontal-bounce-mobile");
          void this.offsetWidth;
          this.classList.toggle("active");
          if (this.cartFooter) {
            this.cartFooter.classList.toggle("active");
          }
        });
      }
    }
  );
}
